import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Cookie auth is primary. Bearer token from localStorage is an optional fallback.
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  // CSRF defense: custom header that cross-site forms/images cannot set.
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Global tenant scope (Super Admin): auto-attach the selected tenant_id to every
  // request unless the caller has already specified one explicitly.
  const activeTenant = localStorage.getItem("active_tenant_id");
  if (activeTenant) {
    const hasTid = config.params && Object.prototype.hasOwnProperty.call(config.params, "tenant_id");
    if (!hasTid) config.params = { ...(config.params || {}), tenant_id: activeTenant };
  }
  return config;
});

// Auth probe/login endpoints legitimately return 401 when logged out — never treat
// those as a "session expired" event (e.g. the /auth/me check on the public landing page).
const AUTH_EXEMPT_401 = ["/auth/me", "/auth/login", "/auth/session", "/auth/demo-login", "/auth/forgot-password", "/auth/reset-password"];

// Global 402 (limit reached / trial ended) handler — broadcasts so a modal can react.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail || "";
    const url = error?.config?.url || "";
    if (status === 402 && /limit|reached|trial/i.test(detail)) {
      const kind = /trial/i.test(detail) ? "trial" : (/user/i.test(detail) ? "user" : "account");
      window.dispatchEvent(new CustomEvent("recoveros:limit", { detail: { message: detail, kind } }));
    }
    // Session expired / revoked mid-use: signal the AuthProvider to log out cleanly.
    if (status === 401 && !AUTH_EXEMPT_401.some((p) => url.includes(p))) {
      window.dispatchEvent(new CustomEvent("recoveros:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export default api;
